import React from 'react';
import { useParams } from 'react-router';

import { Header } from '../components/header/Header';
import { Loading } from '../components/loading';
import { useCXI } from '../useCXI';

import { CXIDashboardRoutes } from './CXIDashboardRoutes';
import { CXIDashboardContextProvider } from './CXIDashboardContext';

import { useCXIDashboard } from './useCXIDashboard';

import * as Nav from './components/navigation';
import * as Styled from './StyledCXIDashboard';

export const CXIDashboardModule = () => {
    const { t } = useCXI();

    const hookd = useCXIDashboard(true);
    const { company } = hookd.vars;

    return !hookd.ready ? (
        <Loading>Carregando Dashboard...</Loading>
    ) : (
        <Styled.CXIDashboard>
            <Styled.CXIDashboardHeader>
                <Header title={`Dashboard ${company.name}`}>
                    <Nav.Navigation>
                        <Nav.Page path="/index">{t('dashboard.tab.all')}</Nav.Page>
                        <Nav.Page path="/stages">{t('dashboard.tab.stages')}</Nav.Page>
                        <Nav.Page path="/users">{t('dashboard.tab.users')}</Nav.Page>
                        <Nav.Page path="/startups">{t('dashboard.tab.startups')}</Nav.Page>
                    </Nav.Navigation>
                </Header>
            </Styled.CXIDashboardHeader>

            <Styled.CXIDashboardRoutes>
                <CXIDashboardRoutes />
            </Styled.CXIDashboardRoutes>
        </Styled.CXIDashboard>
    );
};

export const CXIDashboard = () => {
    const { companyId } = useParams();
    return (
        <CXIDashboardContextProvider companyId={companyId}>
            <CXIDashboardModule />
        </CXIDashboardContextProvider>
    );
};
export default CXIDashboard;
